



















import Vue, { PropType } from "vue";

import { DynamicDocumentItem, DynamicDocumentItemData } from "@/types";
import { isItemRequired } from "@/utilities";

import YesNo from "@/components/YesNo";
import documentCtxMixin from "../document-ctx";

export default documentCtxMixin.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    data: Object as PropType<DynamicDocumentItemData>,
    documentData: Array as PropType<DynamicDocumentItemData[]>
  },

  components: {
    YesNo
  },

  computed: {
    isRequired(): boolean {
      return isItemRequired(this.item, this.documentData ?? [this.data]);
    },

    meta(): Record<string, any> {
      return this.item.meta ?? {};
    }
  }
});
